import sanityClient from "./sanityClient";

export const fetchEventByMeetupNo = async (meetupNo) => {
  const query = `*[_type == "event" && eventMeetupNo == $meetupNo][0]{
    eventMeetupNo,
    eventName,
    date,
    timeFrom,
    timeTo,
    venueName,
    address,
    description,
    url,
    color,
    speakers[]->{
      name,
      title,
      businessName,
      "photo": photo.asset->url
    }
  }`;

  try {
    const event = await sanityClient.fetch(query, {
      meetupNo: parseInt(meetupNo, 10),
    });

    if (!event) return null;

    return {
      ...event,
      speakers: event.speakers
        ? event.speakers.map((speaker) => ({
            ...speaker,
            photoUrl: speaker.photo
              ? `${speaker.photo}?w=2000&h=2000&fm=png&q=100`
              : null,
          }))
        : [],
    };
  } catch (error) {
    console.error("Error fetching event by meetup number:", error);
    return null;
  }
};
